var utils = require("../../utils/utils");

var configurable = function(){
	return {
		$getConfig: function(){
			var own = this.$config.config;
			var global = this.$gantt.config;
			if(own){
				return utils.mixin(own, global);
			}else{
				return global;
			}
		}
	};
};

module.exports = function(obj){
	utils.mixin(obj, configurable());
};


//////////////////
// WEBPACK FOOTER
// ./sources/core/ui/configurable.js
// module id = 14
// module chunks = 0